var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _circle3, _ellipse2, _path8, _path9, _path10, _path11, _circle4, _circle5, _rect, _rect2, _rect3, _rect4, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 206,
    viewBox: "0 0 179 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.759 104C158.759 138.794 128.538 167 91.2588 167C53.9796 167 23.7588 138.794 23.7588 104C23.7588 69.2061 53.9796 41 91.2588 41C128.538 41 158.759 69.2061 158.759 104Z",
    fill: "url(#paint0_linear_46_239)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7588 27H95.7588V43H85.7588V27Z",
    fill: "url(#paint1_linear_46_239)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.7588,
    cy: 15,
    r: 14,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7588 172C131.523 172 163.759 142.003 163.759 105C163.759 82.6271 151.974 62.8154 133.867 50.6466C132.185 49.5167 130.187 48.9738 128.161 48.9738H55.3566C53.3308 48.9738 51.3322 49.5167 49.6508 50.6466C31.5431 62.8154 19.7588 82.6271 19.7588 105C19.7588 142.003 51.9943 172 91.7588 172Z",
    fill: "url(#paint2_linear_46_239)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5214,
    cy: 147.972,
    rx: 5.29423,
    ry: 9.92668,
    transform: "rotate(-44.9872 40.5214 147.972)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.618 157.846C54.3312 155.093 52.0658 148.461 46.5579 143.034C41.0501 137.608 34.3856 135.441 31.6723 138.195C28.959 140.949 31.2245 147.581 36.7323 153.007C42.2402 158.434 48.9047 160.6 51.618 157.846ZM46.8861 154.316C48.6126 152.563 47.1711 148.344 43.6665 144.891C40.1619 141.438 35.9213 140.059 34.1949 141.812C32.4685 143.564 33.91 147.784 37.4146 151.237C40.9191 154.689 45.1597 156.068 46.8861 154.316Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7161 150.302L47.8089 146.373L39.9515 140.187L36.8587 144.116L44.7161 150.302ZM28.9997 157.709L26.6055 153.319L28.9997 157.709ZM22.2632 178.031C24.0979 180.095 27.2582 180.28 29.3221 178.446C31.386 176.611 31.5718 173.451 29.7372 171.387L22.2632 178.031ZM36.8587 144.116C33.6982 148.131 32.437 149.581 31.3971 150.469C30.4168 151.306 29.6594 151.654 26.6055 153.319L31.394 162.098C33.8401 160.764 35.8932 159.779 37.89 158.074C39.8272 156.42 41.7099 154.12 44.7161 150.302L36.8587 144.116ZM26.6055 153.319C22.0684 155.794 19.6928 160.526 18.9729 164.841C18.2574 169.131 18.9604 174.315 22.2632 178.031L29.7372 171.387C29.0398 170.602 28.4491 168.81 28.8367 166.487C29.2199 164.189 30.3441 162.671 31.394 162.098L26.6055 153.319Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.716 150.302L47.8088 146.373L39.9514 140.187L36.8586 144.116L44.716 150.302ZM31 156.709L28.6057 152.319L31 156.709ZM22.3144 178.087C24.1804 180.123 27.3432 180.261 29.3788 178.395C31.4144 176.529 31.5519 173.366 29.686 171.33L22.3144 178.087ZM29.686 171.33C29.527 171.157 29.3933 170.988 29.2805 170.824L21.0528 176.508C21.4317 177.056 21.8525 177.584 22.3144 178.087L29.686 171.33ZM32.7346 161.51C32.964 161.349 33.185 161.212 33.3943 161.098L28.6057 152.319C28.0523 152.621 27.5169 152.956 27.0024 153.316L32.7346 161.51ZM33.3943 161.098C33.6609 160.953 33.9107 160.817 34.1473 160.689L29.3842 151.896C29.1441 152.026 28.8847 152.167 28.6057 152.319L33.3943 161.098ZM44.1927 150.969C44.3602 150.754 44.5345 150.532 44.716 150.302L36.8586 144.116C36.669 144.357 36.4867 144.589 36.3115 144.814L44.1927 150.969Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2076 149.209C50.1456 147.155 48.5676 145.014 46.5579 143.034C43.4413 139.964 39.9543 137.937 37.0224 137.255L38.2595 141.398C39.9746 141.955 41.9127 143.163 43.6665 144.891C45.0727 146.276 46.1468 147.785 46.8173 149.209H51.2076Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.0977,
    cy: 178.098,
    r: 8.83082,
    transform: "rotate(-30.6263 29.0977 178.098)",
    fill: "#5396E3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5557,
    cy: 180.064,
    r: 10.625,
    transform: "rotate(-30.6263 31.5557 180.064)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.29423,
    cy: 9.92668,
    rx: 5.29423,
    ry: 9.92668,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 152.765 144.694)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.906 157.846C128.193 155.093 130.458 148.461 135.966 143.034C141.474 137.608 148.138 135.441 150.852 138.195C153.565 140.949 151.299 147.581 145.792 153.007C140.284 158.434 133.619 160.6 130.906 157.846ZM135.638 154.316C133.911 152.563 135.353 148.344 138.857 144.891C142.362 141.438 146.603 140.059 148.329 141.812C150.055 143.564 148.614 147.784 145.109 151.237C141.605 154.689 137.364 156.068 135.638 154.316Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.808 150.302L134.715 146.373L142.572 140.187L145.665 144.116L137.808 150.302ZM156.5 162.709L160.974 160.475L156.5 162.709ZM150.857 177.351C148.293 178.377 145.383 177.13 144.358 174.566C143.332 172.002 144.579 169.092 147.143 168.066L150.857 177.351ZM145.665 144.116C148.386 147.572 150.939 149.64 153.53 151.823C156.086 153.978 158.972 156.466 160.974 160.475L152.027 164.943C151.033 162.951 149.62 161.606 147.085 159.469C144.584 157.361 141.253 154.679 137.808 150.302L145.665 144.116ZM160.974 160.475C162.265 163.062 162.731 165.804 161.957 168.475C161.209 171.056 159.519 172.818 157.999 173.958C155.294 175.988 151.289 177.178 150.857 177.351L147.143 168.066C147.579 167.892 148.123 167.704 148.519 167.564C148.972 167.404 149.415 167.245 149.861 167.067C150.79 166.695 151.511 166.325 151.998 165.959C152.478 165.599 152.412 165.486 152.352 165.693C152.266 165.989 152.483 165.856 152.027 164.943L160.974 160.475Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.807 150.302L134.714 146.373L142.572 140.187L145.665 144.116L137.807 150.302ZM155.5 161.209L159.973 158.974L155.5 161.209ZM150.505 177.477C147.872 178.308 145.063 176.848 144.232 174.214C143.4 171.581 144.861 168.772 147.494 167.941L150.505 177.477ZM147.494 167.941C147.81 167.841 148.111 167.743 148.398 167.646L151.588 177.124C151.237 177.242 150.876 177.36 150.505 177.477L147.494 167.941ZM151.434 164.279C151.311 164.018 151.175 163.74 151.027 163.443L159.973 158.974C160.147 159.323 160.317 159.671 160.48 160.016L151.434 164.279ZM151.027 163.443C150.893 163.175 150.758 162.931 150.624 162.708L159.187 157.543C159.462 157.999 159.724 158.475 159.973 158.974L151.027 163.443ZM138.684 151.382C138.394 151.035 138.102 150.676 137.807 150.302L145.665 144.116C145.897 144.411 146.126 144.692 146.351 144.961L138.684 151.382Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.316 149.209C132.378 147.155 133.956 145.014 135.966 143.034C139.083 139.964 142.57 137.937 145.502 137.255L144.264 141.398C142.549 141.955 140.611 143.163 138.857 144.891C137.451 146.276 136.377 147.785 135.707 149.209H131.316Z",
    fill: "#468BDC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.098,
    cy: 175.098,
    r: 8.83082,
    transform: "rotate(-30.6263 145.098 175.098)",
    fill: "#5396E3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.556,
    cy: 177.064,
    r: 10.625,
    transform: "rotate(-30.6263 142.556 177.064)",
    fill: "#86B8F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86.7588,
    y: 145,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7588,
    y: 145,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 91.2588,
    y: 142,
    width: 1.5,
    height: 18,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7588,
    y: 67,
    width: 116,
    height: 61,
    rx: 30.5,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7588 98C76.7588 96.6868 76.5001 95.3864 75.9976 94.1732C75.495 92.9599 74.7584 91.8575 73.8299 90.9289C72.9013 90.0003 71.7989 89.2638 70.5856 88.7612C69.3724 88.2587 68.072 88 66.7588 88C65.4456 88 64.1452 88.2587 62.932 88.7612C61.7187 89.2638 60.6163 90.0003 59.6877 90.9289C58.7591 91.8575 58.0225 92.9599 57.52 94.1732C57.0174 95.3864 56.7588 96.6868 56.7588 98",
    stroke: "#72B2FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.759 98C126.759 96.6868 126.5 95.3864 125.998 94.1732C125.495 92.9599 124.758 91.8575 123.83 90.9289C122.901 90.0003 121.799 89.2638 120.586 88.7612C119.372 88.2587 118.072 88 116.759 88C115.446 88 114.145 88.2587 112.932 88.7612C111.719 89.2638 110.616 90.0003 109.688 90.9289C108.759 91.8575 108.023 92.9599 107.52 94.1732C107.017 95.3864 106.759 96.6868 106.759 98",
    stroke: "#72B2FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_239",
    x1: 91.2588,
    y1: 27,
    x2: 91.2588,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_46_239",
    x1: 91.2588,
    y1: 27,
    x2: 91.2588,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_46_239",
    x1: 91.7588,
    y1: 38,
    x2: 91.7588,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.149b9c6ee4283399a7e0f7cf392e9fab.svg";
export { ForwardRef as ReactComponent };